// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import filterPaths from './filterPaths'
import sortPaths from './sortPaths'

import { updateVisiblePathIds } from 'redux/modules/projectSummary'

// takes all the project's paths from redux state and then creates
// a list of pathIds which are filtered and sorted based on projectSummary pieces
// (project summary filter and project summary path summary table sorting respectively.)
// this list of path ids is used to render the path summary table

const filterAndSortPathIds = () => (dispatch, getState) => {
  // so you got all this project's paths
  const paths = getState().projectSummary.get('paths')

  // first filter them based on the filter in the project header
  const filteredPaths = dispatch(filterPaths(paths))

  // then sort the filtered subset according to the active tableSort values
  const sortedPaths = dispatch(sortPaths(filteredPaths))

  // then simplify the filtered, sorted paths down to just their ids
  const filteredAndSortedPathIds = sortedPaths.reduce((a, d, i) => {
    a.push(d.get('pathId'))
    return a
  }, [])

  // finally store this set to redux state for rendering
  dispatch(updateVisiblePathIds(filteredAndSortedPathIds))
}

export default filterAndSortPathIds
